import { IntlShape } from 'react-intl';
import { AxiosGetType } from '../context/FetchProvider';
import { MenuProductComponent } from '../types/products';
import { productComponents } from '@osmosis/shared/products';
import { LIBRARY_URL } from './urls';

type MessageArray = (
  intl: IntlShape,
) => Record<string, Pick<MenuProductComponent, 'title' | 'subtitle'>>;

/**
 * Fetch user tools.
 */
export const fetchTools = (get: AxiosGetType) => async () => {
  const [
    res,
    {
      data: { redirect: libraryRedirect },
    },
  ] = await Promise.all([
    // Get base user tools
    get<{ tools: MenuProductComponent[] }>('/v0/user_tools'),

    // Pre-fetch user's default library page so we don't have to
    // redirect from base /library
    get<{ redirect?: string }>('/v0/library_redirect', {
      params: { url: LIBRARY_URL },
    }),
  ]);

  const toolKeys = res?.data?.tools.map((t) => t.type);

  const tools = toolKeys
    .map((key) => productComponents[key])
    .map((p) => {
      // Populate with user's library page
      if (p.url === LIBRARY_URL && libraryRedirect) {
        return {
          ...p,
          url: libraryRedirect,
        };
      }

      // Otherwise don't modify
      return p;
    })
    .filter(Boolean);

  return tools;
};

/**
 * Get localized product components.
 * @param intl - React-intl instance.
 * @returns Localized product components.
 */
export const getLocalizedProductComponents = (
  intl: IntlShape,
  messageArray: MessageArray,
): Record<string, Pick<MenuProductComponent, 'title' | 'subtitle'>> =>
  messageArray(intl);
